import { cartItemMapping } from './cartItemMapping'
import { MappingItem } from '../../GTM'

export const checkoutStepData = (
    itemMapping = cartItemMapping()
): MappingItem => {
    return {
        actionField: function (data: { step?: string; option?: string }) {
            return {
                step: data?.step,
                option: data?.option
            }
        },
        currency: ['cart', 'prices', 'grand_total', 'currency'],
        productsDetails: {
            data_source: ['cart', 'items'],
            mapping: itemMapping,
            strict: true
        }
    }
}
